import CardCompositeScore from './CardCompositeScore';
import './CardCompositeScore.scss';

export default CardCompositeScore;
